import { render, staticRenderFns } from "./server-volume-info.vue?vue&type=template&id=730ec1f4&scoped=true&"
import script from "./server-volume-info.vue?vue&type=script&lang=js&"
export * from "./server-volume-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730ec1f4",
  null
  
)

export default component.exports